import React from 'react';
import styled from 'styled-components';

import { ButtonPrimary } from '@yuhu-inc/yuhui';
import Row from 'components/ui/Row';
import Col from 'components/ui/Col';
import Spacer from 'components/ui/Spacer';
import AntdForm from 'components/ui/Form';
import TextBox from 'components/ui/TextBox';
import Select from 'components/ui/SelectField';

import { colors } from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';
import { extractSuffix, ADDITIONAL_FIELDS } from 'helpers/DocumentTemplateHelper';

const FIELD_TYPES = [
  {
    value: 'text',
    label: getTranslatedString('landlordPortal.documentTemplate.fieldType.text'),
  },
  {
    value: 'checkbox',
    label: getTranslatedString('landlordPortal.documentTemplate.fieldType.checkbox'),
  },
];

const StyledFieldCardContainer = styled.div`
  width: 100%;
  margin-top: 15px;
  background-color: ${colors.WHITE};
  border-radius: 16px;
  padding: 24px 24px 0px;
`;

const FullWidthText = styled(TextBox)`
  width: 100%;
`;

const StyledFieldCardCTAContainer = styled.div`
  border-top: 1.5px solid ${colors.PALE_GREY};
  margin-left: 12px;
  margin-right: 12px;
  display: flex;
  justify-content: flex-end;
  padding-top: 5px;
`;

const StyledCtaHR = styled.div`
  border-left: 1px solid ${colors.PALE_GREY};
`;

const StyledCta = styled(ButtonPrimary)`
  background-color: transparent !important;
  font-size: 16px;
`;

const AdditionalField = ({
  additionalField,
  values,
  setFieldValue,
  index,
  errors,
  handleRemoveField,
  documentTemplateTitle,
}) => {
  const errorCheck = errors['additional_fields'] && errors['additional_fields'][index];

  return (
    <StyledFieldCardContainer>
      <Spacer mb={1}>
        <Row gutter={16}>
          <Col span={24}>
            <AntdForm.Item
              label={getTranslatedString('landlordPortal.documentTemplate.fieldName')}
              validateStatus={errorCheck?.label && 'error'}
              help={errorCheck?.label}
            >
              <FullWidthText
                placeholder={getTranslatedString('landlordPortal.maintenance.placeHolder.enter')}
                size="large"
                value={extractSuffix(
                  additionalField.label,
                  ADDITIONAL_FIELDS,
                  documentTemplateTitle
                )}
                onChange={(e) => {
                  setFieldValue(`focusIndex`, index);
                  setFieldValue(`additional_fields[${index}].label`, e.target.value);
                }}
              />
            </AntdForm.Item>
          </Col>
        </Row>
      </Spacer>
      <Spacer mb={1}>
        <Row gutter={16}>
          {/* only allow text type to change default value. If checkbox, default value is "true" */}
          {additionalField.field_type === 'text' && (
            <Col span={14}>
              <AntdForm.Item
                label={getTranslatedString('landlordPortal.documentTemplate.fieldValue')}
                validateStatus={errorCheck?.default_value && 'error'}
                help={errorCheck?.default_value}
              >
                <FullWidthText
                  placeholder={getTranslatedString('landlordPortal.maintenance.placeHolder.enter')}
                  size="large"
                  value={additionalField.default_value}
                  onChange={(e) =>
                    setFieldValue(`additional_fields[${index}].default_value`, e.target.value)
                  }
                />
              </AntdForm.Item>
            </Col>
          )}

          <Col span={10}>
            <AntdForm.Item
              label={getTranslatedString('landlordPortal.documentTemplate.fieldType')}
              validateStatus={errorCheck?.field_type && 'error'}
              help={errorCheck?.field_type}
            >
              <Select
                name="field_type"
                size="large"
                value={additionalField.field_type}
                onChange={(val) => {
                  if (val === 'checkbox') {
                    setFieldValue(`additional_fields[${index}].field_type`, val);
                    // only allow text type to change default value. If checkbox, default value is "true"
                    setFieldValue(`additional_fields[${index}].default_value`, 'true');
                  } else {
                    setFieldValue(`additional_fields[${index}].field_type`, val);
                  }
                }}
              >
                {FIELD_TYPES.map((fieldType) => (
                  <Select.Option value={fieldType.value}>{fieldType.label}</Select.Option>
                ))}
              </Select>
            </AntdForm.Item>
          </Col>
        </Row>
      </Spacer>

      <Spacer mb={1}>
        <Row gutter={24}>
          <StyledFieldCardCTAContainer>
            <StyledCtaHR />
            <StyledCta
              type="button"
              contentKey="landlordPortal.documentTemplate.delete"
              onClick={() => handleRemoveField(values, index, setFieldValue)}
            />
          </StyledFieldCardCTAContainer>
        </Row>
      </Spacer>
    </StyledFieldCardContainer>
  );
};

export default AdditionalField;
